export interface PinnedProduct {
  mpvId: string;
  position: number;
}

export const pinnedProductPositionCompareFn = (a: PinnedProduct, b: PinnedProduct): number => {
  return a.position - b.position;
};
